import { SegmentSchema } from '@sondermind/segment';

export interface IAccountCompleteData {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  submitted_at: string;
}

export interface IBasicInfoStarted {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  ac_type: BasicInfoStartedType;
}

export enum BasicInfoStartedType {
  PROPOSE_A_TIME = 'PaT',
  REQUEST_TO_SCHEDULE = 'RtS',
  INDEPENDENT = 'Independent'
}

export enum CurrentUserSegmentEvents {
  ACCOUNT_COMPLETED = 'Account Completed',
  BASIC_INFO_STARTED = 'Basic Info Started'
}

export interface ICurrentUserSegmentSchema extends SegmentSchema {
  [CurrentUserSegmentEvents.ACCOUNT_COMPLETED]: IAccountCompleteData;
  [CurrentUserSegmentEvents.BASIC_INFO_STARTED]: IBasicInfoStarted;
}
